<template>
  <b-table
    class="sticky-table-header"
    :data="inventoriesRefills"
    :default-sort="['createdAt', 'desc']"
    narrowed
    hoverable
  >
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <b-table-column
      field="createdAt"
      :label="$t('inventoriesRefills.date')"
      v-slot="props"
      sortable
    >
      <span class="adjust-top">
        {{
          new Date(props.row.createdAt).toLocaleDateString(
            undefined,
            refillDateFormat
          )
        }}
      </span>
    </b-table-column>

    <b-table-column
      field="originStore.storeInfo.name"
      :label="$t('inventoriesRefills.origin')"
      sortable
      searchable
      v-slot="props"
    >
      <span class="adjust-top">
        {{ getOriginStoreName(props.row) }}
      </span>
    </b-table-column>

    <b-table-column
      field="store.storeInfo.name"
      :label="$t('inventoriesRefills.destiny')"
      sortable
      searchable
      v-slot="props"
    >
      <span class="adjust-top">
        {{ getStoreName(props.row) }}
      </span>
    </b-table-column>

    <b-table-column
      field="store.storeInfo.name"
      :label="$t('inventoriesRefills.store')"
      sortable
      searchable
      v-slot="props"
    >
      <span class="adjust-top">
        {{ getStoreName(props.row) }}
      </span>
    </b-table-column>

    <b-table-column
      field="operation"
      :label="$t('inventoriesRefills.operation')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">
        {{ getOperationLabel(props.row) }}
      </span>
    </b-table-column>

    <b-table-column
      field="inventoryType"
      :label="$t('inventoriesRefills.type')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">
        {{
          props.row.inventoryType === "full"
            ? $t("inventoriesRefills.full")
            : props.row.inventoryType === "partial"
            ? $t("inventoriesRefills.partial")
            : "-"
        }}
      </span>
    </b-table-column>

    <b-table-column
      v-if="permissions.downloadRefillsAndInventories"
      :label="$t('inventoriesRefills.download')"
      v-slot="props"
    >
      <button
        class="button is-small"
        @click="downloadInventoryRefill(props.row)"
      >
        <b-icon icon="file-download" size="is-medium"></b-icon>
      </button>
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>{{ $t("common.tableEmptyMessage") }}</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { getOperationName } from "../../utils/inventoryRefill";

export default {
  props: ["inventoriesRefills"],

  mixins: [common],

  data() {
    return {
      isLoading: false,
      refillDateFormat: {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
    };
  },

  methods: {
    getOperationLabel(refill) {
      const operation = getOperationName(refill);

      return [
        "inventory",
        "loss",
        "management",
        "newProduct",
        "manageProducts"
      ].includes(operation)
        ? this.$t(`inventoriesRefills.${operation}`)
        : this.$t("inventoriesRefills.refill");
    },

    getOriginStoreName(refill) {
      if (!refill || !refill.origin) {
        return "-";
      }

      if (refill.origin === "direct-from-market") {
        return this.$t("inventoriesRefills.directFromMarket");
      }

      return refill.originStore &&
        refill.originStore.storeInfo &&
        refill.originStore.storeInfo.name
        ? refill.originStore.storeInfo.name
        : "-";
    },

    getStoreName(refill) {
      return refill &&
        refill.store &&
        refill.store.storeInfo &&
        refill.store.storeInfo.name
        ? refill.store.storeInfo.name
        : "-";
    },

    downloadInventoryRefill(refill) {
      this.isLoading = true;
      this.$store
        .dispatch("downloadInventoryRefill", refill)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>

<style scoped>
.adjust-top {
  position: relative;
  top: 3px;
}
</style>
